<template>
  <v-container v-if="isLoaded">
    <v-form ref="search-job-execution-details-form">
      <v-card class="mt-5">
        <base-card-title
          icon="mdi-clipboard-list-outline"
          label="View Job Executions"
        />
        <v-card-text class="pl-8 pr-8">
          <v-row>
            <v-col
              md="3"
              class="pb-0 pt-0"
            >
              <base-input-select
                :items="jobNames"
                item-label="Job name"
                item-value="key"
                item-text="description"
                :selected-value="searchCriteria.jobName"
                @change="(val) => searchCriteria.jobName = val"
              />
            </v-col>
            <v-col
              md="3"
              class="pb-0 pt-0"
            >
              <base-input-select-date-picker
                item-label="Creation date (from)"
                :show-week="true"
                :rules="[rules.fromDateIsBeforeToDate]"
                :selected-value="searchCriteria.creationFromDate"
                @change="(val) => searchCriteria.creationFromDate = val"
              />
            </v-col>
            <v-col
              md="3"
              class="pb-0 pt-0"
            >
              <base-input-select-date-picker
                item-label="Creation date (to)"
                :show-week="true"
                :rules="[rules.fromDateIsBeforeToDate, rules.toDateNotAfterToday]"
                :selected-value="searchCriteria.creationToDate"
                @change="(val) => searchCriteria.creationToDate = val"
              />
            </v-col>
            <v-col
              md="3"
              class="pb-0 pt-0"
            >
              <base-input-select
                :items="jobStatuses"
                item-label="Status"
                item-value="value"
                item-text="name"
                :selected-value="searchCriteria.jobStatus"
                @change="(val) => searchCriteria.jobStatus = val"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
    <div class="mt-2">
      <base-input-search-and-clear-buttons
        class="d-inline"
        @search="search"
        @reset="reset"
      />
    </div>
    <v-card
      v-if="items.length >= 1"
      class="mt-10"
    >
      <base-table-paged-with-search
        :table-headers="headers"
        :items="items"
      />
    </v-card>
  </v-container>
</template>

<script>
import BaseCardTitle from '@/base/card/BaseCardTitle.vue'
import BaseInputSelect from '@/base/input/BaseInputSelect.vue'
import BaseInputSelectDatePicker from '@/base/input/BaseInputSelectDatePicker.vue'
import BaseInputSearchAndClearButtons from '@/base/input/BaseInputSearchAndClearButtons.vue'
import BaseTablePagedWithSearch from '@/base/table/BaseTablePagedWithSearch.vue'
import { validateDate } from '@/validation/customvalidation'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'JobExecutionDetails',
  components: {
    BaseCardTitle,
    BaseInputSelect,
    BaseInputSelectDatePicker,
    BaseInputSearchAndClearButtons,
    BaseTablePagedWithSearch
  },
  data () {
    return {
      isLoaded: false,
      items: [],
      jobNames: [],
      searchCriteria: this.initCriteria(),
      jobStatuses: [
        { name: 'STARTING', value: 'STARTING' },
        { name: 'STARTED', value: 'STARTED' },
        { name: 'COMPLETED', value: 'COMPLETED' },
        { name: 'STOPPING', value: 'STOPPING' },
        { name: 'STOPPED', value: 'STOPPED' },
        { name: 'FAILED', value: 'FAILED' },
        { name: 'ABANDONED', value: 'ABANDONED' }
      ],
      headers: [
        { text: 'Job name', align: 'start', sortable: false, value: 'jobName' },
        { text: 'Status', align: 'start', sortable: false, value: 'jobStatus' },
        { text: 'Exit status', align: 'center', sortable: false, value: 'exitStatus' },
        { text: 'Start time', align: 'center', sortable: false, value: 'startTime' },
        { text: 'End time', align: 'center', sortable: false, value: 'endTime' }
      ],
      rules: {
        fromDateIsBeforeToDate: value => validateDate(this.searchCriteria.creationFromDate, value) ||
          'To date cannot be before from date.',
        toDateNotAfterToday: value => !value || moment(value).isSameOrBefore(moment(), 'day') ||
          'To date cannot be after today\'s date.'
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('getUser')
    this.loadJobNames()
    this.isLoaded = true
  },
  methods: {
    initCriteria () {
      return {
        jobName: '',
        jobStatus: '',
        creationFromDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        creationToDate: moment().format('YYYY-MM-DD')
      }
    },
    loadJobNames () {
      axios.get('/api/touchpoint/batch-job-executions/job-name-details')
        .then(response => {
          this.jobNames = response.data.sort((a, b) => a.description.localeCompare(b.description))
        })
        .catch(e => console.error('Failed to load job names', e))
    },
    search () {
      if (this.$refs['search-job-execution-details-form'].validate()) {
        this.items = []
        axios.post('/api/touchpoint/batch-job-executions/criteria-search', this.searchCriteria)
          .then(response => {
            this.items = response.data.map(data => ({
              jobName: data.jobName,
              jobStatus: data.jobStatus,
              exitStatus: data.exitStatus,
              startTime: data.startTime,
              endTime: data.endTime
            }))
          })
          .catch(e => console.error('Failed to search job executions', e))
      }
    },
    reset () {
      this.$refs['search-job-execution-details-form'].resetValidation()
      this.searchCriteria = this.initCriteria()
      this.items = []
    }
  }
}
</script>
